import { addInstrumentationHandler, logger } from '@sentry/utils';
import { IS_DEBUG_BUILD } from './flags.js';
import { getActiveTransaction } from './utils.js';

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  addInstrumentationHandler('error', errorCallback);
  addInstrumentationHandler('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  var activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    var status = 'internal_error';
    IS_DEBUG_BUILD && logger.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

export { registerErrorInstrumentation };
//# sourceMappingURL=errors.js.map
